export default __webpack_public_path__ + "static/media/format.37a8596c.svg";